
import { mapGetters, mapActions, mapState } from "vuex"
import AppFooter from "@soenergy/frontend-library/src/components/AppFooter"
import AppHeader from "@soenergy/frontend-library/src/components/AppHeader"
import HeaderContainer from "@/components/HeaderContainer"
import CookieManager from "@soenergy/frontend-library/src/components/CookieBanner/CookieManager"
import * as CookieConsentPlugin from "@soenergy/frontend-library/src/services/CookieConsentPlugin"

export default {
  name: "FormLayout",
  components: {
    AppHeader,
    AppFooter,
    HeaderContainer,
    CookieManager
  },
  async fetch() {
    await this.fetchLayoutContent()
  },
  computed: {
    ...mapState({
      isProspectSwitchJourneyEnabled: state =>
        state.contentManagement.isProspectSwitchJourneyEnabled,
      userStatus: state => state.userStatus.userStatus
    }),
    ...mapGetters("contentManagement", [
      "header",
      "footer",
      "cookieModal",
      "cookieBanner"
    ])
  },
  methods: {
    ...mapActions("contentManagement", ["fetchLayoutContent"]),
    reopenCookieModal() {
      if (this.$config.isThirdPartyCookieConsentEnabled) {
        CookieConsentPlugin.openPreferencesModal()
      } else {
        this.$refs.CookieManager.showModal()
      }
    }
  }
}
